import { apiClient } from "@api/apiClient";
import {
  GetArticleInfoResponse,
  ReviewRequiredInformation,
} from "@api/articleInfo/articleInfo.interface";

import type {
  PutArticleInfoArg,
  PutArticleInfoResponse,
} from "@interface/articleInfo.interface";

export const API_ENDPOINT = {
  get: "/des/draft-article/info",
  update: "/des/draft-article/update",
  reviewRequiredUpdate: "/des/draft-article/review-required",
};

export const articleInfoApis = {
  get: async (draftArticleId: number) => {
    const { data } = await apiClient.get<GetArticleInfoResponse>(
      `${API_ENDPOINT.get}/${draftArticleId}`,
    );

    return data;
  },
  put: async (articleInfo: PutArticleInfoArg) => {
    const { data } = await apiClient.put<PutArticleInfoResponse>(
      API_ENDPOINT.update,
      articleInfo,
    );

    return data;
  },
  reviewRequiredPut: async (
    pressId: number,
    { isReviewRequired, reviewId, newInfoDetails }: ReviewRequiredInformation,
  ) => {
    const url = `${API_ENDPOINT.reviewRequiredUpdate}/?id=${pressId}`;
    const { data } = await apiClient.put(url, {
      isReviewRequired,
      reviewId,
      newInfoDetails,
    });

    return data;
  },
};
